const ru = {
  ourProjects: 'Наши проекты',
  usernameIsTaken: 'Имя пользователя занято',
  settingsTxt: 'Настройки',
  myProfileTxt: 'Мой профиль',
  bobName: 'Боб - ИИ Ассистент',
  awarenessTest: 'Игра на внимание',
  findSolutions: 'Находим решения ваших проблем',
  learnAboutUXCore: 'зучаем паттерны мышления',
  podcast: 'Подкаст',
  arcOfSelf: 'Arc of Self',
  arcOfSelfTooltip: 'Рекурсивная теория личности',
  done: 'Готово',
  usefulLinks: [
    {
      title: '',
      items: [
        {
          title: 'Использование проекта в образовательной системе',
          link: '/ru/articles/uxeducation',
        },
      ],
    },
    {
      title: 'UX CORE GUIDE',
      items: [
        {
          title: 'Добавление вашего вопроса',
        },
      ],
    },
    {
      title: 'UX CORE PERSONA',
      items: [
        {
          title: 'Вводная статья',
          icon: 'habr-logo',
          link: 'https://habr.com/ru/post/670722/',
          alt: 'Habr.com publishing platform logo',
        },
      ],
    },
    {
      title: '',
      items: [
        {
          title: 'API',
          icon: 'api',
          link: '/ru/uxcore-api',
          target: '',
          alt: 'UX Core API',
        },
      ],
    },
  ],
};

export default ru;
